<div class="page-container">
    <div class="page-body-container">
		<div class="card h-full md:h-auto md:w-2/6">
			<div class="card-header-container">
				<h1 class="card-header">Bestätigung</h1>
			</div>
			<h1>{{message}}</h1>
			<div class="button-row">
				<button class="btn-primary" [routerLink]="'/anmeldung'" >
					<span>Zum Login</span>
				</button>
			</div>
		</div>
    </div>
</div>
